<template>
  <div class="sp-freelancer-client-info">
    <avatar-upload class="avatar" :file-url="avatarUrl"  @changed='avatarChanged'/>
    <s-p-freelancer-client-info-form
      :value="spFreelancerRegistrationClientInfo"
      @changed="formChanged"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SPFreelancerClientInfoForm from '@/components/spFreelancerRegistration/SPFreelancerClientInfoForm.vue';
import {
  CHANGE_SP_FREELANCER_AVATAR,
  CHANGE_SP_FREELANCER_CLIENT_REGISTRATION_DATA,
} from '@/store/spFreelancerRegistration/actionTypes';
import AvatarUpload from '@/components/common/AvatarUpload.vue';

export default {
  name: 'SPFreelancerClientInfo',
  components: {
    SPFreelancerClientInfoForm,
    AvatarUpload,
  },
  data() {
    return {
      recaptchaUserToken: null,
      avatarUrl: null,
    };
  },
  computed: {
    ...mapGetters([
      'spFreelancerRegistrationClientInfo',
    ]),
  },
  async mounted() {
    await this.$recaptchaLoaded();
    this.$recaptchaInstance.showBadge();
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge();
  },
  methods: {
    formChanged(value) {
      this.$store.dispatch(CHANGE_SP_FREELANCER_CLIENT_REGISTRATION_DATA, value);
    },
    avatarChanged(file) {
      this.avatarUrl = file;
      this.$store.dispatch(CHANGE_SP_FREELANCER_AVATAR, file);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.avatar {
  flex: 0.75;
  margin-right: 7%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sp-freelancer-client-info {
  display: flex;
  flex: 0.7;
  margin: 0 0;

  padding-top: rem(40);
  padding-bottom: rem(40);

  padding-left: rem(118);
  padding-right: rem(152);

  border-radius: $radius-sm;
  background-color: $white;
  box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);

  .client-info-form {
    flex: 1;
  }
}
</style>
